import cn from 'classnames';
import * as React from 'react';
import { Button } from 'reactstrap';
import { BubbleCommand } from '../_shared/constants';
import { BubbleChannel } from '../client/src/modules/_core/components/BubbleChannel';
import { BytesizeIcon } from '../client/src/modules/_core/components/BytesizeIcon';
import { HeaderClass } from '../client/src/modules/_core/components/Header/Header';
import { PageChatClass } from '../client/src/modules/_core/components/PageChat/PageChat';
import { PageHome } from '../client/src/modules/_core/components/PageHome/PageHome';
import { config } from '../client/src/modules/_core/config';
import { url } from '../client/src/modules/_core/url';
import { getSessionThreadId, removeSessionThreadId, setSessionTheadId, } from '../client/src/modules/_core/utils/app-storage';
import { I18nMsgNs } from '../client/src/modules/_core/utils/i18n-helpers';
import { ChatMessage } from '../client/src/modules/chat/ChatMessage';
import { TextMessageClass } from '../client/src/modules/chat/components/Messages/TextMessage';
import DropdownWithModal from './DropdownWithModal';
import { TooltipWrapper } from './sazka/components/TooltipWrapper';
import { headerOnCloseHandler } from './sazka/externals-fns/header-close-handler';
import './sazka/sazka.scss';
import { dataLayerPush } from './utils';
export var initializeExternals = function () {
    var B = config.css.B('-header');
    ChatMessage.groupLabelResolver = function (msg) {
        if (msg.is_bot)
            return 'GOODBOT';
        else if (msg.is_agent)
            return 'AGENT';
        else
            return 'USER';
    };
    /**
     * @param cmp
     * @param threadId
     * @param prevThreadId
     */
    PageChatClass.threadIdHandler = function (cmp, threadId, prevThreadId) {
        if (threadId !== prevThreadId) {
            removeSessionThreadId();
            setSessionTheadId(threadId);
        }
        var isOpen = JSON.parse(sessionStorage.getItem('bubble-isOpen')) || {};
        var isShown = JSON.parse(sessionStorage.getItem('bubble-isShown')) || {};
        if (isOpen.payload && isShown.payload)
            setSessionTheadId(threadId);
    };
    PageHome.getInitialRoute = function () {
        var threadId = getSessionThreadId();
        if (threadId) {
            return url.CHAT(threadId);
        }
        else {
            return url.CHAT();
        }
    };
    /**
     * @param cmp
     */
    PageHome.onInitialDataHandler = PageHome.onStartNewClick;
    PageHome.rendererMain = function (cmp) {
        var Msg = I18nMsgNs('PageHome');
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "gaid-page-home__texts" },
                React.createElement("h1", null,
                    React.createElement(Msg, { id: "startWelcome" })),
                React.createElement("p", null,
                    React.createElement(Msg, { id: "startWelcomeDesc" }))),
            React.createElement("div", { className: "gaid-page-home__buttonwrap" },
                React.createElement(Button, { color: "primary", onClick: function () {
                        PageHome.onStartNewClick();
                        // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
                        dataLayerPush({
                            eventAction: 'RedButton',
                            eventLabel: 'Zacat Chat',
                        });
                    } },
                    React.createElement(Msg, { id: "startNew" })),
                React.createElement("div", { className: "gaid-page-home__footer" }, "powered by Born Digital"))));
    };
    var openStaffino = false;
    var toggleStaffino = function () {
        openStaffino = !openStaffino;
    };
    HeaderClass.rendererLeftBox = function (cmp) { return (React.createElement(DropdownWithModal, { cmp: cmp, openStaffino: openStaffino, handleCancel: function () {
            openStaffino = false;
            return openStaffino;
        } })); };
    HeaderClass.rendererRightBox = function (cmp) {
        return (React.createElement(React.Fragment, null,
            React.createElement(TooltipWrapper, { content: "Minimalizovat", target: "minimaze" }),
            React.createElement("button", { id: "minimaze", className: cn("".concat(B, "__boxbutton")), onClick: function (e) {
                    e.preventDefault();
                    BubbleChannel.postCommand(BubbleCommand.HIDE);
                } },
                React.createElement(BytesizeIcon, { name: "minimize", size: "small", thickness: "medium" })),
            React.createElement(TooltipWrapper, { content: "Zav\u0159\u00EDt", placement: "bottom-end", target: "close" }),
            React.createElement("button", { id: "close", className: cn("".concat(B, "__boxbutton")), onClick: function (e) {
                    e.preventDefault();
                    headerOnCloseHandler(cmp, toggleStaffino);
                    // Remove focus bcs of stucked tooltip
                    if (document.activeElement instanceof HTMLElement)
                        document.activeElement.blur();
                } },
                React.createElement(BytesizeIcon, { name: "close", size: "small", thickness: "medium" }))));
    };
    HeaderClass.rendererMainBox = function (cmp) {
        var B = config.css.B('-header');
        return (React.createElement("div", { className: cn("".concat(B, "__logobox")) },
            React.createElement("h1", null, "CHAT")));
    };
    TextMessageClass.messageTimestampFormatter = function (message, cmp) {
        return new Date(message.created).toLocaleTimeString('cs-CZ', {
            hour: '2-digit',
            minute: '2-digit',
        });
    };
};
